/**
 * DevExtreme (esm/__internal/core/templates/m_child_default_template.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { TemplateBase } from "../../../core/templates/template_base";
export class ChildDefaultTemplate extends TemplateBase {
  constructor(name) {
    super();
    this.name = name;
  }
}